import "aos/dist/aos.css";
import { useEffect, useState, useRef } from "react";
import Header from "./dashboard/header";
import getContract from "../services/contract";
import { ethers } from "ethers";
import { FaRocket } from "react-icons/fa";
import { IoMdSwap } from "react-icons/io";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { FaClipboardList } from "react-icons/fa";
import { FaFlagCheckered } from "react-icons/fa";
import { MdGeneratingTokens } from "react-icons/md";
import { FaUserLock } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import Footer from "./footer";
import AOS from "aos";
import { TransactionService } from '../services/transactionService'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import getWallet, { disconnectWallet, onChange } from '../services/wallet';
import getTokenContract from '../services/tokenContract';
import { useNavigate, useLocation } from "react-router-dom";
import queryString from 'query-string';
import {
  AiFillAccountBook,
  AiFillCopy,
  AiOutlinePaperClip,
  AiOutlineShareAlt,
} from "react-icons/ai";

const Home = (props) => {
  const navigate = useNavigate();
  const location = useLocation(); 

  const isFirstRender = useRef(true);

  let [signer, setSigner] = useState(null);
  let [loginId, setLoginId] = useState('');
  let [referrerId, setReferrerId] = useState(1);
  let [isConnected, setIsConnected] = useState(0);
  let [balance, setBalance] = useState(0);
  let [userAddress, setUserAddress] = useState('');
  let [usdtAddress, setUsdtAddress] = useState('');

  let [totalValue, setTotalValue] = useState(0);
  let [totalMembers, setTotalMembers] = useState(0);

  const [activeIndex, setActiveIndex] = useState(null);

  const notify = (message) => toast(message);

  const handleConnectWallet = async () => {
    await connectWallet();
  };

  const handleDisconnect = async () => {
    setBalance(0);
    setSigner(null);
    setUserAddress('');
    setIsConnected(false);
    disconnectWallet();
  }
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    connectWallet();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1500 });
    async function getData() {
      try {
        
        const contract = await getContract();
        const lastIdCount = await contract.lastIDCount()
        setTotalMembers(
          ethers.BigNumber.from(lastIdCount).toNumber()
        );
        
        const valueInvestedBN = await contract.totalValueInvested();
        
        const totalInvested = +ethers.utils.formatUnits(
          valueInvestedBN
        );
        
        setTotalValue(totalInvested);
        
        const token = await getTokenContract();
        setUsdtAddress(token.address);
        
        // await getBalance();

      } catch (error) {
        console.log(error);
      }
    }
    getData();
  }, []);

  useEffect(() => {
    if (location.search) {
        const { refid } = queryString.parse(location.search); // Parse URL query params
        console.log(refid);
        
        if (refid) {
            setReferrerId(refid); // Update state with refId from URL
        }
    }
  }, [location.search])

  useEffect(() => {
    if(!signer) return
    getBalance();
    // if (isFirstRender.current) {
    //   // Skip first render
    //   isFirstRender.current = false;
    //   return;
    // }
  } , [signer]);

  const addToMetamask = async () => {
    try {
      // wasAdded is a boolean. Like any RPC method, an error may be thrown.
      const wasAdded = await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', // Initially only supports ERC20, but eventually more!
          options: {
            address: usdtAddress, // The address that the token is at.
            // address: '0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8', // The address that the token is at.
            symbol: 'USDT', // A ticker symbol or shorthand, up to 5 chars.
            decimals: 18, // The number of decimals in the token
          },
        },
      });

      if (wasAdded) {
        console.log('Thanks for your interest!');
      } else {
        console.log('Your loss!');
      }
    } catch (error) {
      console.log(error);
    }
  }

  const connectWallet = async () => {
    const wallet = await getWallet();
    if (!wallet.isReadOnly) {
      // if(wallet.isWrongNetwork) {
      //     throw new Error('Switch to Polygon');
      //     return;
      // }

      const browserAddresses = await wallet.provider.listAccounts();
      
      setUserAddress(browserAddresses[0]);
      setIsConnected(true);
      setSigner(wallet.signer);

    } else {
      // throw new Error('Wallet not connected');
    }
  }

  const getBalance = async () => {
    const token = await getTokenContract();
    
    const balance = await token.balanceOf(userAddress);
    if(balance.gt(ethers.BigNumber.from("0"))) {
        const totalBalanceBN = balance.div(ethers.BigNumber.from("1000000000000000000"));
        const totalBalance = ethers.BigNumber.from(totalBalanceBN).toString();
        setBalance(totalBalance);

    }
    // const wallet = await getWallet();
    // if(!wallet.isReadOnly) {
    // }
  }

  const handleRegister = async () => {
    const wallet = await getWallet();
    if (!isConnected) {
      alert('Connect wallet');
      return;
    }
    try {
      var transactionService = new TransactionService(0, userAddress);
      const registrationPromise = transactionService.register(referrerId);
      const newId = await toast.promise(
        registrationPromise,
        {
          pending: `Registering under ID: ${referrerId}`,
          success: 'Success !!',
          error: 'Register failed'
        },
        {
          position: toast.POSITION.BOTTOM_CENTER 
        }
      )
      console.log(newId);
      
      if (newId > 0) { 
        navigate('/dashboard/' + newId);
      }
    } catch (error) {
      console.log(error);
      alert(error.message);
    }
  } 

  const handleViewClick = async () => {
    const contract = await getContract();
    const id = loginId;
    const lastId = ethers.BigNumber.from(
      await contract.lastIDCount()
    ).toNumber();
    if (lastId < id || id < 1) {
      alert(`User Id ${id} not found`);
      return;
    }
    // this.props.router.navigate("/dashboard/" + id);
    navigate("/dashboard/" + id);
  }

  const handleLogin = async () => {
    const wallet = await getWallet();
    if (!wallet.isReadOnly) {
      const browserAddresses = await wallet.provider.listAccounts();
      const contract = await getContract();
      const id = ethers.BigNumber.from(
        await contract.getIdByAddress(browserAddresses[0])
      ).toNumber();
      if (id == 0) {
        alert(
          "No id found with your connected wallet make sure switch to joined account on metamask"
        );
        return;
      }
      navigate("/dashboard/" + id);
    }
  };

  const accordions = [
    {
      id: 0,
      title: "What is Elephants Money?",
      body: "It is a platform of Decentralized Network which is developed on Binance Blockchain (PoS). It is a smart contracts that are easily accessible for everybody, can't be changed, Elephants Money is the most powerful, highly secure and transparent distributed finance application",
    },
    {
      id: 1,
      title: "What is Plan of Auto Re-Run?",
      body: "Funds Distribution compose of, Matrix Level Bonus (75%) by 5%, 10%,50% respectively, 25% for direct sponsor and 10% for 10 uni-level. Documents can see at Dashboard, you can download.",
    },
    
    {
      id: 2,
      title: "Where to learn more?",
      body: "Please follow our official channel or social network that provide link at the footer of homepage",
    },
   {
      id: 3,
      title: "What is Elephant Token?",
      body: "It is Token of platform that will be distributed to all registered wallets, equal to amount of registration by USDT, and will be ale to trade on most popular DEX in the near future.",
   },
  ];

  return (
    <div id="home">
      <ToastContainer
        position="bottom-center"
        theme="colored"
        autoClose={10000}
        style={{ zIndex: 1 }}
      /> <ToastContainer />

      <Header
        isHome={true}
        userAddress={userAddress}
        onConnectWallet={handleConnectWallet}
        signer={signer}
        onDisconnect={handleDisconnect}
      />
      <section
        className="banner"
        style={{ backgroundImage: "url(/logo/bg3.jpg)" }}
      >
        <div className="banner-sections">
          <div className="logo-sec" data-aos="fade-right">
            <img
              src="/logo/logo.png"
              style={{ width: "500px", margin: "0 auto" }}
            />
         </div>
          
        </div>
      </section>
      <section className="custom-container authentication-section">
        <div className="login" data-aos="fade-right">
          <h3>Login to view</h3>
          <input onChange={(e) =>  setLoginId(e.target.value) } value={loginId} id="idbyPlan" type="number" placeholder="Enter Id" />
          <div className="actions">
            <button onClick={handleViewClick} className="button lightBtn">Search</button>
            <button onClick={handleLogin} className="button primaryBtn">Login</button>
          </div>
        </div>
        <div className="register" data-aos="fade-left">
          <div className="register-form">
            <h3>Join under ID</h3>
            <input onChange={(e) => setReferrerId(e.target.value) } value={referrerId} id="idbyPlan" type="number" placeholder="Enter Upline Id" />
            <div className="requireAmount">
              <i className="las la-info-circle text-3xl text-base"></i>
              <span>Start with 5 USDT</span>
            </div>
            <span className="balance">USDT: {balance} </span>
            <div className="actions">
              <button onClick={handleRegister} className="button lightBtn">REGISTER</button>
             {/* <button onClick={addToMetamask} className="button primaryBtn">Add USDT To Wallet</button>
              <button onClick={addIpToMetamask} className="button primaryBtn">Add IP Token To Wallet</button>
              */}
              </div>
          </div>
          <div className="info-card">
            <div className="heading">
              <h4>How to Invest</h4>
            </div>
            <p>
              Access the website via Metamask mobile app or use browser
              extension. For Mobile users use Trust wallet app or Tocken Pocket
              (TP) for choices
            </p>
            <div className="heading">
              <h4>How To Access Dashboard</h4>
            </div>
            <p>
              You'll automatically navigate to Dashboard after joining OR Access
              Your Dashboard Via Homepage Login Button
            </p>
          </div>
        </div>
      </section>
      <div
        className="grid grid-cols-4 dashboard-copy-grid items-center mb-5"
        style={{ gap: "10px" }}
      >
        <div className="col-span-2 grid-left text-center">
          
          <div
            className="grid grid-cols-2"
            style={{ gap: "10px", marginTop: "10px" }}
          >
            <div
              className="border p-5 rounded-md"
              style={{
                borderColor: "rgb(244, 197, 7)",
                background: " #47fec78f",
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                Total Account
              </h3>
              <div className=" text-center">
                <h2 style={{ fontSize: "18px" }}>{totalMembers}</h2>
                {/* <AiFillAccountBook style={{ fontSize: "30px" }} /> */}
              </div>
            </div>
            <div
              className="border p-5 rounded-md"
              style={{
            borderColor: "rgb(244, 197, 7)",
                background: " #47fec78f",
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                Total USDT
              </h3>
              <div className=" text-center">
                <h2 style={{ fontSize: "18px" }}>{totalValue}</h2>
                {/* <AiFillAccountBook style={{ fontSize: "30px" }} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <section>
        <div className="custom-container roadmap">
          <h6 className="section-heading" data-aos="fade-up">
            ROADMAP
          </h6>
          <span data-aos="fade-up">
            Our roadmap is the journey of IP Token, guiding us through various
            phases to build a strong foundation, engage the community, and
            achieve decentralized growth. Here's a look at what's ahead:
          </span>
          <div className="roadmap-phase" data-aos="fade-left">
            <FaRocket />
            <h6>Phase 1: Launch</h6>
            <p>
            Launch of Platform ||
            Investment value of 10 million baht ||
            Amount of Account: Over 3,000 ||
            IP coin price: $0.0007             
            </p>
          </div>
          <div className="roadmap-phase" data-aos="fade-right">
            <IoMdSwap />
            <h6>Phase 1: Presale and Staking</h6>
            <p>
              The early supporters and buyers of IP Token from the presale will
              be offered a unique opportunity. They will have the chance to
              stake their tokens directly into the smart contract even before
              the official listing, and get high early Annual Percentage Yield
              (APY) advantage.
            </p>
          </div>
          <div className="roadmap-phase" data-aos="fade-left">
            <FaMoneyCheckDollar />
            <h6>Phase 1: Presale and Staking</h6>
            <p>
              The early supporters and buyers of IP Token from the presale will
              be offered a unique opportunity. They will have the chance to
              stake their tokens directly into the smart contract even before
              the official listing, and get high early Annual Percentage Yield
              (APY) advantage.
            </p>
          </div>
          <div className="roadmap-phase" data-aos="fade-right">
            <FaClipboardList />
            <h6>Phase 1: Presale and Staking</h6>
            <p>
              The early supporters and buyers of IP Token from the presale will
              be offered a unique opportunity. They will have the chance to
              stake their tokens directly into the smart contract even before
              the official listing, and get high early Annual Percentage Yield
              (APY) advantage.
            </p>
          </div>
          <div className="roadmap-phase" data-aos="fade-left">
            <FaFlagCheckered />
            <h6>Phase 1: Presale and Staking</h6>
            <p>
              The early supporters and buyers of IP Token from the presale will
              be offered a unique opportunity. They will have the chance to
              stake their tokens directly into the smart contract even before
              the official listing, and get high early Annual Percentage Yield
              (APY) advantage.
            </p>
          </div>
        </div>
      </section> */}
      {/* <section>
        <div className="custom-container roadmap">
          <h6 className="section-heading" data-aos="fade-up">
            RECENT ACTIVITIES
          </h6>
          <span data-aos="fade-up">
            Our roadmap is the journey of IP Token, guiding us through various
            phases to build a strong foundation, engage the community, and
            achieve decentralized growth. Here's a look at what's ahead:
          </span>
          <div className="activities" data-aos="fade-right">
            <div className="activity-item">
              <div>
                <FaRocket />
                <span>ID: 200</span>
              </div>
              <p>Phase 1: Presale and Staking</p>
              <div>
                <FaRocket />
                <span>Sat March 15, 2025</span>
              </div>
            </div>
            <div className="activity-item">
              <div>
                <FaRocket />
                <span>ID: 201</span>
              </div>
              <p>Phase 1: Presale and Staking</p>
              <div>
                <FaRocket />
                <span>Sat March 15, 2025</span>
              </div>
            </div>
            <div className="activity-item">
              <div>
                <FaRocket />
                <span>ID: 202</span>
              </div>
              <p>Phase 1: Presale and Staking</p>
              <div>
                <FaRocket />
                <span>Sat March 15, 2025</span>
              </div>
            </div>
            <div className="activity-item">
              <div>
                <FaRocket />
                <span>ID: 203</span>
              </div>
              <p>Phase 1: Presale and Staking</p>
              <div>
                <FaRocket />
                <span>Sat March 15, 2025</span>
              </div>
            </div>
            <div className="activity-item">
              <div>
                <FaRocket />
                <span>ID: 203</span>
              </div>
              <p>Phase 1: Presale and Staking</p>
              <div>
                <FaRocket />
                <span>Sat March 15, 2025</span>
              </div>
            </div>
            <div className="activity-item">
              <div>
                <FaRocket />
                <span>ID: 203</span>
              </div>
              <p>Phase 1: Presale and Staking</p>
              <div>
                <FaRocket />
                <span>Sat March 15, 2025</span>
              </div>
            </div>
            <div className="activity-item">
              <div>
                <FaRocket />
                <span>ID: 203</span>
              </div>
              <p>Phase 1: Presale and Staking</p>
              <div>
                <FaRocket />
                <span>Sat March 15, 2025</span>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section>
        <div className="custom-container roadmap">
          <h6 className="section-heading" data-aos="fade-up">
            FAQ
          </h6>
          <span data-aos="fade-up">
            We have provided major frequently Asked Questions (FAQ) by below, strongly recommend to join our communities of social network for more detials.
          </span>
          <div className="qna" data-aos="fade-up">
            <div
              className="panel-group"
              id="accordion"
              role="tablist"
              aria-multiselectable="true"
            >
              {accordions.map((item) => (
                <div key={item.id} className="panel panel-default">
                  <div className="panel-heading" role="tab">
                    <h4 className="panel-title">
                      <a
                        className={activeIndex === item.id ? "" : "collapsed"}
                        role="button"
                        onClick={() => toggleAccordion(item.id)}
                        aria-expanded={activeIndex === item.id}
                      >
                        {item.title}
                      </a>
                    </h4>
                  </div>
                  <div
                    className={`panel-collapse collapse ${
                      activeIndex === item.id ? "show" : ""
                    }`}
                    role="tabpanel"
                  >
                    <div className="panel-body">
                      <p>{item.body}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Home;
